// @flow weak
import React        from 'react';
import PropTypes    from 'prop-types';
import UserMenu     from './userMenu/UserMenu';
import TaskMenu     from './taskMenu/TaskMenu';
import MessageMenu  from './messageMenu/MessageMenu';
import Button       from './button/Button';
import ViewLink                             from '../../components/aside/asideLeft/menu/menuLinks/viewLink/ViewLink.js';
import { Link }         from 'react-router-dom';
const Header = ({
  userLogin,
  userFirstname,
  userLastname,
  userPicture,
  showPicture,
  appName,
  currentView,
  toggleSideMenu,
  onLogout,
  sideMenu,
  superUser,
  partner,
  accessConfig,
}) => (
  <header
    className="header fixed--header">
    <a href="#" style={{backgroundImage: 'linear-gradient(to right, #141e30, #243b55)'}}
      className="logo">
      { appName }
    </a>
    <div className="navbar navbar-static-top" role="navigation" >
      <div className="top-navigation-menu" style={{backgroundImage: 'linear-gradient(to right, #141e30, #243b55)'}}>
        <div style={{display:'flex', flexDirection: 'row', justifyContent: 'space-around'}}>
          <div>
          { accessConfig != 'Technichal Partner' ?
          (<ViewLink
            key={'1'}
            isActive={true}
            linkTo={'/partnerDashboard'}
            viewName={'Dashboard'}
            faIconName={'fa-bar-chart'}
            itemCount= { 0}
          />)
          :
          (<ViewLink
            key={'1'}
            isActive={true}
            linkTo={'/partnerBFC'}
            viewName={'Dashboard'}
            faIconName={'fa-bar-chart'}
            itemCount= { 0}
          />)
        }
        { accessConfig != 'Technichal Partner' ?
            ('')
            :
            (<ViewLink
            key={'15'}
            isActive={true}
            linkTo={'/bfcKidslist'}
            viewName={'Students List'}
            faIconName={'fa-child'}
            itemCount= { 0}
          />)

          }
           { accessConfig != 'Technichal Partner' ?
          (<ViewLink
            key={'2'}
            isActive={true}
            linkTo={'/partnerAcademy'}
            viewName={'F-Academy'}
            faIconName={'fa-child'}
            itemCount= { 0}
          />)
          :
          ('')
        }
          { accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'3'}
            isActive={true}
            linkTo={'/partnerFootball'}
            viewName={'Football Improve'}
            faIconName={'fa-futbol-o'}
            itemCount= { 0}
          />)
            :
            ('')

          }
          { accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'4'}
            isActive={true}
            linkTo={'/PartnerPlay'}
            viewName={'Football Play'}
            faIconName={'fa-rub'}
            itemCount= { 0}
          />)
            :
            ('')

          }
          { accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'5'}
            isActive={true}
            linkTo={'/partnerCourtBooking'}
            viewName={'Rental'}
            faIconName={'fa-registered'}
            itemCount= { 0}
          />)
            :
            ('')

          }
          { accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'6'}
            isActive={true}
            linkTo={'/partnerBadminton'}
            viewName={'Badminton Improve'}
            faIconName={'fa-bold'}
            itemCount= { 0}
          />)
            :
            ('')

          }
          { accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'11'}
            isActive={true}
            linkTo={'/partnerBadmintonAcademy'}
            viewName={'Badminton Academy'}
            faIconName={'fa-btc'}
            itemCount= { 0}
          />)
            :
            ('')

          }
          { accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'12'}
            isActive={true}
            linkTo={'/partnerBadmintonPlay'}
            viewName={'Badminton Play'}
            faIconName={'fa-product-hunt'}
            itemCount= { 0}
          />)
            :
            ('')

          }
          { accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'8'}
            isActive={true}
            linkTo={'/partnerTournament'}
            viewName={'Events'}
            faIconName={'fa-trophy'}
            itemCount= { 0}
          />)
            :
            ('')

          }
          { accessConfig != 'Technichal Partner' ?
            (<ViewLink
            key={'9'}
            isActive={true}
            linkTo={'/collection'}
            viewName={'Collection'}
            faIconName={'fa-rupee'}
            itemCount= { 0}
          />)
            :
            ('')

          }
        
          </div>
          <div style={{float:'right'}}>
            <Link style={{marginRight: '5%', padding: '2%'}}
                    to={'/login'}
                    onClick={onLogout}
                    >
                    <span style={{fontSize: '14px'}}>
                      {'Logout'}
                    </span>
            </Link>
          </div>
        </div>
      </div>
    </div>

  </header>
);
Header.propTypes = {
  appName:        PropTypes.string,
  userLogin:      PropTypes.string,
  userFirstname:  PropTypes.string,
  userLastname:   PropTypes.string,
  userPicture:    PropTypes.string,
  showPicture:    PropTypes.bool,
  onLogout:       PropTypes.func,
  currentView:    PropTypes.string,
  toggleSideMenu: PropTypes.func
};
Header.defaultProps = {
  appName: 'applicationName'
};
Header.displayName = 'Header';
export default Header;



// WEBPACK FOOTER //
// ./src/app/components/header/Header.js